var map = {
	"./element.js": "WntM",
	"./menus.js": "83Y+",
	"./public.js": "TjDs"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "jRH+";


//////////////////
// WEBPACK FOOTER
// ./src/i18n/langs/en nonrecursive \.js$
// module id = jRH+
// module chunks = 13